/* -------------------------------------------------------------------------- */
/*                                Breadcrumb item styles                */
/* -------------------------------------------------------------------------- */

@import './bq-breadcrumb-item.variables';

:host([aria-current='page']) {
  .breadcrumb-item {
    @apply text-[color:--bq-breadcrumb-item--text-color-current];
  }
}

.breadcrumb-item {
  @apply border-[length:--bq-breadcrumb-item--border-width] border-[color:--bq-breadcrumb-item--border-color];
  @apply rounded-[--bq-breadcrumb-item--border-radius] bg-[--bq-breadcrumb-item--background] shadow-[shadow:--bq-breadcrumb-item--box-shadow];
  @apply pe-[--bq-breadcrumb-item--padding-end] ps-[--bq-breadcrumb-item--padding-start] p-b-[--bq-breadcrumb-item--paddingY];
  @apply text-[length:--bq-breadcrumb-item--text-size] font-regular leading-[--bq-breadcrumb-item--line-height] text-[color:--bq-breadcrumb-item--text-color];
  @apply focus-visible:focus hover:text-hover-brand active:outline-none;
  @apply transition-colors duration-300 ease-in-out;
  @apply cursor-pointer no-underline;

  border-style: var(--bq-avatar--border-style);
}

.breadcrumb-separator {
  @apply flex items-center text-[length:--bq-breadcrumb-item--text-size-separator];
  @apply pe-[--bq-breadcrumb-item--padding-end-separator] ps-[--bq-breadcrumb-item--padding-start-separator];
}
